import $, { extend } from 'jquery';
import 'react-bootstrap/dropdown';
import Popper from 'popper.js';
//import {Popper} from '@popperjs/core';
import React from 'react';

import "jquery-ui-bundle/jquery-ui";
import "jquery-ui-bundle/jquery-ui.css";

import 'react-bootstrap/modal';

import 'react-bootstrap/tooltip';

import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker,
  btnSetColor_CBack,RespBkMthdMapp_CBack} from '../function_lib/common_lib';

import {CompGetAcademicYear} from '../components/comp_auto_complete';
import {CompGetCurriculum,CompGetAcademicProgram} from '../components/comp_auto_complete';
import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from './header';
import Footer from './footer';

import Comp_CRB_Cadet_Admin from '../lms_component/comp_crb_cadet_admin';

import defaultPic from '../assets/images/9.png';



import Comp_Class_Fee_Master from '../components/comp_class_fee_master';
import Comp_Edit_Student_Basic from '../components/comp_edit_student_basic';
import Comp_Edit_Student_Family from '../components/comp_edit_student_family';
import Comp_Edit_Student_Auth from '../components/comp_edit_student_auth';



let loginUser="";
let userObject="";
let companyName="";
let clsStudentAdmission;

let rf="0";
window.Popper = Popper;

let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];
class View_Student_Performance extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={ stCadetAllCRB:{},stListTask:[],stListClassFee:[],stListSessionYear:[],stListClassMaster:[],
        stListFeeCategory:[],stLsStudentBasic:[],stLsStudentFamily:[],stLsStudentAuth:[],stStudentId:"0"};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsStudentAdmission=this;
      }
//******  for child component function

editStudentBasic(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentBasic",function(data,msg){
      if(data==="001"){
          alert("Updated Successfully");
          clsStudentAdmission.getStudentAdmission();
      }
  })
}
editStudentFamily(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentFamily",function(data,msg){
    if(data==="001"){
        alert("Updated Successfully");
        clsStudentAdmission.getStudentAdmission();
    }
})
}
editStudentAuth(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentAuth",function(data,msg){
    if(data==="001"){
        alert("Updated Successfully");
        clsStudentAdmission.getStudentAdmission();
    }
})
}

//**** end of child component function
getSubTask(item){
   //alert(JSON.stringify(item));
  // return;
  var map=[];
  map.push({name:"curl_type",value:"getSubTaskCRB_New"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"mem_id",value:btoa(item.id)});
  map.push({name:"user_type",value:userObject[0].type});
  
 
  map.push({name:"upper_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getSubTaskCRB_New";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    // alert(data);
    if(data!=="0" && data!==""){
      let listData=JSON.parse(data);
      //alert(data);
      //stLsCurriculam
      clsStudentAdmission.setState({stListTask:listData.task_crb,stCadetAllCRB:listData},()=>{
        
RespBkMthdMapp_CBack(clsStudentAdmission,"e_click_class",function(event){
let chref=event.target.getAttribute("chrf")
//alert();
clsStudentAdmission.setState({stSetHrfPdf:chref},()=>{
  clsStudentAdmission.forceUpdateHandler();
$("#divPdfView").modal('show');
})     
//alert(JSON.stringify(data));
//props.runSearch(data);
},"chrf");
      });
    }
  })

}


      getStudentAdmission(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getStudentRecord"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"ser_session_year",value:$("#ser_session_year").val()});
        map.push({name:"ser_academic_prog",value:$("#ser_academic_prog").val()});
        map.push({name:"ser_curriculum",value:$("#ser_curriculum").val()});
        map.push({name:"ser_stu_gender",value:$("#ser_stu_gender").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
       

        //alert($("#ser_session_year").val());
        //map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getStudentRecord";
        CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                $(".outstanding_rpt").html("Total :"+listData.length+" Records Found");
                
                clsStudentAdmission.setState({stListClassFee:listData},()=>{
                  //window.getPagination("#tbData");
                  clsStudentAdmission.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful","Record Added Successfully",true);
          clsStudentAdmission.getClassMaster();
          $("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",smg,false);
        }
        // alert(data);
      }
stubasic_okSucc(data,msg){
  alert(data);
}      

onStudentDetailsEdit(item){
  let map=[];
  map.push({name:"curl_type",value:"getMastStudentData"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:userObject[0].type});
  map.push({name:"stu_id",value:btoa(item.id)});
  //alert($("#ser_session_year").val());
  //map.push({name:"upper_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastStudentData";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    if(data!=="0"){
      let lsData=JSON.parse(data);
      clsStudentAdmission.setState({stLsStudentBasic:lsData.ls_stu_basic,
      stLsStudentFamily:lsData.ls_stu_family,stLsStudentAuth:lsData.ls_stu_auth,
      stStudentId:item.id},()=>{
        clsStudentAdmission.forceUpdateHandler();
      })
    }
  })
}

getMasters(){
  var map=[];
  map.push({name:"curl_type",value:"getMastersRequest"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastersRequest";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
          let listData=JSON.parse(data);
          var strData="";
          //alert(JSON.stringify(listData.master_balance));
          clsStudentAdmission.setState({
            stListSessionYear:listData.ls_session_year,
            stListClassMaster:listData.ls_class_master,
          stListFeeCategory:listData.ls_fee_category},()=>{
            clsStudentAdmission.forceUpdateHandler();
          })
        }
  });
}
          
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getStudentAdmission();
this.getMasters();

$('#divEditStudentBasic').on('hidden.bs.modal', function () {
  window.location.reload();
});
$('#divEditStudentFamily').on('hidden.bs.modal', function () {
  window.location.reload();
});
$('#divEditStudentAuth').on('hidden.bs.modal', function () {
  window.location.reload();
});

}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
{/* for now [row]it is unused */}
{/* starting of cols */}

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">

         <CompGetAcademicYear userObject={userObject} comp_id="ser_session_year" comp_name="ser_session_year" placeHolder="Academic Year" propClass="form-control required" />
              
             </div>
         
         </div>
</div>

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
          <CompGetAcademicProgram userObject={userObject} comp_id="ser_academic_prog" comp_name="ser_academic_prog" placeHolder="Academic Program" propClass="form-control" />
              
             </div>
         
         </div>
</div>

<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
         <CompGetCurriculum userObject={userObject} comp_id="ser_curriculum" comp_name="ser_curriculum" placeHolder="Curriculum" propClass="form-control required" />
             
             </div>
         
         </div>
</div>


<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_stu_gender" name="ser_stu_gender" className="form-control form-control-sm">
                <option value={"0"}>-Gender-</option>
                {genderList.map((item,index)=>{
                                                    return <option value={item}>{item}</option>
                                                  })}

               </select>
             </div>
         
         </div>
</div>


<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" className="_setSearchKeyUp form-control form-control-sm" placeholder='search by Stu.Name,CDC,Enrollment' />
             </div>
         
         </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getStudentAdmission()}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 <div  className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>
</div>
{/* end of cols */}

    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Student List</b></h3>
                <div className="outstanding_rpt float-left px-10"></div>
                <a className="btn btn-sm btn-danger float-right" href="../student_admission">Add New Student</a>
              </div>
                <table id="tbData" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>CDC No.</th>
                      <th>Student Name</th>
                      <th>Gender</th>
                      <th>Session Year</th>
                      <th>Acad. Program</th>
                      <th>Indos No</th>
                      <th>Enrol. No</th>
                      <th>Ref. No.</th>
                      {/* <th>Total Fee</th> */}
                      <th>Admission Date</th>
                      
                      <th>Is Active</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.stListClassFee.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                        <td>{item.mem_no}</td>
                        <td>{item.full_name}</td>
                        <td>{item.gender}</td>
                        <td>{item.session_name}</td>
                        <td>{item.academic_program}</td>  
                        <td>{item.indos_no}</td>
                        <td>{item.enrollment_no}</td>
                        <td>{item.ref_no}</td>
                 <td>{item.commenced_date}</td>
                  <td>{item.status}</td>
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                   
                     <a class="dropdown-item" onClick={()=>this.getSubTask(item)} data-bs-toggle="modal" data-bs-target="#divCRBCadetAdminView" data-toggle="modal" data-target="#divCRBCadetAdminView" href="javascript:void(0)">Check CRB</a>
                     <a class="dropdown-item" onClick={()=>this.getSubTask(item)} data-toggle="modal"  data-target="#divEditStudentFamily" href="javascript:void(0)">View Certificates</a>
                     <a class="dropdown-item" href="../student_task_list">Check Task</a>
                    </div>
                  </div>
                  </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
<Comp_CRB_Cadet_Admin cadetAllCRB={this.state.stCadetAllCRB} task_list={this.state.stListTask}/>
    {/* <Comp_Edit_Student_Basic editStudentBasic={this.editStudentBasic} genderList={genderList} castCategoryList={castCategoryList} lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsStudentBasic={this.state.stLsStudentBasic} app_user_id={userObject[0].app_user_id} />
    <Comp_Edit_Student_Family editStudentFamily={this.editStudentFamily} studentId={this.state.stStudentId}  lsStudentFamily={this.state.stLsStudentFamily}/>
    <Comp_Edit_Student_Auth editStudentAuth={this.editStudentAuth} lsClassMaster={this.state.stListClassMaster} studentId={this.state.stStudentId} lsStudentAuth={this.state.stLsStudentAuth}/> */}
    {/* <Comp_Class_Fee_Master lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsFeeCategory={this.state.stListFeeCategory} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default View_Student_Performance;